import { vTooltip } from './tooltip';
import { vLazySrc } from '@/composables/useLazyImage';

/**
 * Register all custom directives globally
 * @param {import('vue').App} app - Vue application instance
 */
export function registerDirectives(app) {
  app.directive('tooltip', vTooltip);
  app.directive('lazy-src', vLazySrc);
}

export { vTooltip, vLazySrc };
